var defaultLocale = function(I18n) {
    const navigatorLang = () => (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';
    var langFirstTwo = navigatorLang().slice(0, 2);
    I18n.changeLanguage(langFirstTwo);
}

exports.defaultLocale = defaultLocale;